import {
  isPaymentExcludedAsInternal,
  isSuccessfulPayment,
  paymentAmountUsd,
  getPaymentTimestampMs,
} from "./metrics";

const STORAGE_KEY = "scanbrix_crm_data_quality_v1";

export const DEFAULT_DATA_QUALITY = {
  excludeInternal: true,
  excludeTest: true,
  excludeSandbox: true,
  excludeDev: true,
};

export function loadDataQuality() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? { ...DEFAULT_DATA_QUALITY, ...JSON.parse(raw) } : { ...DEFAULT_DATA_QUALITY };
  } catch {
    return { ...DEFAULT_DATA_QUALITY };
  }
}

export function saveDataQuality(filters) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(filters));
}

function strHas(s, parts) {
  const x = String(s || "").toLowerCase();
  return parts.some((p) => x.includes(p));
}

export function isTestPayment(p) {
  if (!p) return false;
  if (p.test === true || p.is_test === true || p.livemode === false) return true;
  if (strHas(p.email || p.customer_email, ["test@", "example.com", "+test"])) return true;
  const meta = p.metadata || {};
  return meta.test === true || strHas(p.id, ["test_", "ch_test"]);
}

export function isSandboxPayment(p) {
  return p?.sandbox === true || p?.environment === "sandbox" || strHas(p?.id, ["sandbox"]);
}

export function isDevPayment(p) {
  const meta = p?.metadata || {};
  return meta.dev === true || strHas(meta.source, ["dev", "development", "localhost"]);
}

export function shouldExcludePayment(p, contacts, filters, excludedIds = new Set()) {
  if (!isSuccessfulPayment(p)) return "not_successful";
  if (excludedIds.has(p.id)) return "manual_exclude";
  if (filters.excludeInternal && isPaymentExcludedAsInternal(contacts, p)) return "internal";
  if (filters.excludeTest && isTestPayment(p)) return "test";
  if (filters.excludeSandbox && isSandboxPayment(p)) return "sandbox";
  if (filters.excludeDev && isDevPayment(p)) return "development";
  return null;
}

export function filterPayments(payments, contacts, filters, excludedIds = new Set()) {
  const included = [];
  const excluded = [];
  for (const p of payments || []) {
    const reason = shouldExcludePayment(p, contacts, filters, excludedIds);
    if (reason) excluded.push({ payment: p, reason });
    else included.push(p);
  }
  return { included, excluded };
}

export function sumFilteredPayments(payments, contacts, filters, excludedIds, start, end) {
  const { included } = filterPayments(payments, contacts, filters, excludedIds);
  let sum = 0;
  for (const p of included) {
    const t = getPaymentTimestampMs(p);
    if (start != null && t < start) continue;
    if (end != null && t > end) continue;
    sum += paymentAmountUsd(p);
  }
  return sum;
}
